<app-watchlist-agent-info pageType="other" [agentInfo]="watchlistAgentInfo"></app-watchlist-agent-info>

<div class="mt-4 md:mt-10 relative">
    <nz-tabset>
        <nz-tab nzTitle="Wallets">
            <app-watchlist-smart-buys [watchlistId]="watchlistId"></app-watchlist-smart-buys>
        </nz-tab>

        <nz-tab nzTitle="Recent TG Alerts ({{recentTgAlerts.length}})">
            <div class="md:absolute md:top-1.5 md:right-0 max-md:mb-3">
                <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="fetchAlerts()"></app-chain-select>
            </div>

            <div class="space-y-3">
                <app-recent-tg-alert-item *ngFor="let item of recentTgAlerts" [alertItem]="item" class="block"></app-recent-tg-alert-item>
            </div>

            <nz-skeleton *ngIf="fetchingRecentTgAlerts" [nzActive]="true"></nz-skeleton>

            <app-no-data *ngIf="!recentTgAlerts.length && !fetchingRecentTgAlerts"></app-no-data>
        </nz-tab>
    </nz-tabset>
</div>
